import React, { Component } from "react";
import Resume from "../../../Assets/img/resume2.png";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import swal from "sweetalert";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import styles from "./MakeResume.module.scss";
import { TiDelete } from "react-icons/ti";
import { FiArrowLeft } from "react-icons/fi";
import { BsPlusLg } from "react-icons/bs";
import HeaderResume from "../../Hoc/Header.Resume";

// ==================== Wrapper برای React Router v6 ====================
function SingleResumeWrapper(props) {
  const { id } = useParams();
  return <SingleResume {...props} resumeId={id} />;
}

// ==================== کامپوننت اصلی ====================
class SingleResume extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      age: "",
      language: "",
      userId: "",
      address: "",
      city: "",
      gender: "",
      maritalStatus: "",
      militaryService: "",
      skill: "",
      educations: [],
      skills: [],
      works: [],
      work: "",
      company: "",
      from: "",
      to: "",
      description: "",
      university: "",
      major: "",
      grade: "",
      fromE: "",
      toE: "",
      descriptionE: "",
      user: [],
      resume_id: "",
      resumeEdus: [],
      resumeSkills: [],
      resumeWorks: [],
      loading: false,
      invalidName: false,
      invalidPhone: false,
      invalidEmail: false,
      invalidCity: false,
      invalidAge: false,
      invalidMarital: false,
      invalidGender: false,
      invalidMilitary: false,
      invalidEnglish: false,
      page1: true,
      page2: false,
      page3: false,
      page4: false,
    };

    this.onChange = this.onChange.bind(this);
    this.createResume = this.createResume.bind(this);
    this.newEdu = this.newEdu.bind(this);
    this.newSkill = this.newSkill.bind(this);
    this.newWork = this.newWork.bind(this);
    this.nameChangeHandler = this.nameChangeHandler.bind(this);
    this.phoneChangeHandler = this.phoneChangeHandler.bind(this);
    this.emailChangeHandler = this.emailChangeHandler.bind(this);
    this.cityChangeHandler = this.cityChangeHandler.bind(this);
    this.ageChangeHandler = this.ageChangeHandler.bind(this);
    this.genderChangeHandler = this.genderChangeHandler.bind(this);
    this.militaryChangeHandler = this.militaryChangeHandler.bind(this);
    this.englishChangeHandler = this.englishChangeHandler.bind(this);
    this.goNext1 = this.goNext1.bind(this);
    this.goNext2 = this.goNext2.bind(this);
    this.goNext3 = this.goNext3.bind(this);
    this.goBack2 = this.goBack2.bind(this);
    this.goBack3 = this.goBack3.bind(this);
    this.goBack4 = this.goBack4.bind(this);
  }

  componentDidMount() {
    console.log("resumeId:", this.props.resumeId);
    this.getUser();
    this.getResumeInfo();
  }

  getUser() {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        console.log("user", response.data);
        this.setState({ user: response.data });
      })
      .catch((err) => console.log(err));
  }

  getResumeInfo() {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-one-resume/${this.props.resumeId}`
      )
      .then((res) => {
        console.log("resumeData", res);
        const data = res.data;
        this.setState({
          name: data[0]?.name || "",
          email: data[0]?.email || "",
          phone: data[0]?.phone || "",
          city: data[0]?.city || "",
          language: data[0]?.language || "",
          age: data[0]?.age || "",
          gender: data[0]?.gender || "",
          militaryService: data[0]?.militaryService || "",
          maritalStatus: data[0]?.maritalStatus || "",
          educations: data[1] || [],
          skills: data[2] || [],
          works: data[3] || [],
          resumeEdus: data[1] || [],
          resumeSkills: data[2] || [],
          resumeWorks: data[3] || [],
          resume_id: data[1]?.[0]?.resume_id?.[0] || data[0]?._id || "",
        });
      })
      .catch((err) => console.log(err));
  }

  // ==================== تغییر اصلی: وضعیت سربازی دیگر اجباری نیست ====================
  goNext1() {
    const s = this.state;
    if (!s.name) {
      return swal({ title: "!خطا", text: "!فیلد نام را پر کنید", icon: "error", button: "!باشه" });
    }
    if (!s.phone || s.phone.length !== 11) {
      return swal({ title: "!خطا", text: "!شماره تماس ۱۱ رقمی وارد کنید", icon: "error", button: "!باشه" });
    }
    if (!s.email) {
      return swal({ title: "!خطا", text: "!فیلد ایمیل را پر کنید", icon: "error", button: "!باشه" });
    }
    if (!s.age) {
      return swal({ title: "!خطا", text: "!فیلد سن را پر کنید", icon: "error", button: "!باشه" });
    }
    if (!s.city) {
      return swal({ title: "!خطا", text: "!فیلد شهر را پر کنید", icon: "error", button: "!باشه" });
    }
    if (!s.gender) {
      return swal({ title: "!خطا", text: "!فیلد جنسیت را پر کنید", icon: "error", button: "!باشه" });
    }
    if (!s.maritalStatus) {
      return swal({ title: "!خطا", text: "!فیلد وضعیت تاهل را پر کنید", icon: "error", button: "!باشه" });
    }
    // وضعیت سربازی حذف شد - اختیاری است
    if (!s.language) {
      return swal({ title: "!خطا", text: "!فیلد زبان را پر کنید", icon: "error", button: "!باشه" });
    }
    this.setState({ page1: false, page2: true });
  }

  goNext2() {
    this.setState({ page2: false, page3: true });
  }
  goNext3() {
    this.setState({ page3: false, page4: true });
  }
  goBack2() {
    this.setState({ page2: false, page1: true });
  }
  goBack3() {
    this.setState({ page3: false, page2: true });
  }
  goBack4() {
    this.setState({ page4: false, page3: true });
  }

  newEdu() {
    const { university, major, grade, fromE, toE, descriptionE } = this.state;
    if (fromE && toE && fromE > toE) {
      return swal({ title: "اضافه نشد", text: "!لطفا تاریخ درست انتخاب کنید", icon: "error", button: "!باشه" });
    }
    if (!university && !major && !grade && !fromE && !toE) {
      return swal({ title: "اضافه نشد", text: "!فیلد تحصیل را پر کنید", icon: "error", button: "!باشه" });
    }
    const education = this.state.educations.concat({
      university,
      major,
      grade,
      from: fromE,
      to: toE,
      description: descriptionE,
    });
    this.setState({
      educations: education,
      major: "",
      grade: "",
      university: "",
      fromE: "",
      toE: "",
      descriptionE: "",
    });
  }

  newSkill() {
    if (!this.state.skill) {
      return swal({ title: "اضافه نشد", text: "!فیلد مهارت را پر کنید", icon: "error", button: "!باشه" });
    }
    this.setState({
      skills: [...this.state.skills, this.state.skill],
      skill: "",
    });
  }

  newWork() {
    const { work, company, from, to, description } = this.state;
    if (from && to && from > to) {
      return swal({ title: "اضافه نشد", text: "!لطفا تاریخ درست انتخاب کنید", icon: "error", button: "!باشه" });
    }
    if (!work && !company && !from && !to) {
      return swal({ title: "!اضافه نشد", text: "!فیلد شغل را پر کنید", icon: "error", button: "!باشه" });
    }
    this.setState({
      works: [...this.state.works, { work, company, from, to, description }],
      work: "",
      company: "",
      from: "",
      to: "",
      description: "",
    });
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  nameChangeHandler(e) {
    this.setState({ name: e.target.value, invalidName: e.target.value.length === 0 });
  }
  phoneChangeHandler(e) {
    this.setState({ phone: e.target.value, invalidPhone: e.target.value.length === 0 });
  }
  emailChangeHandler(e) {
    this.setState({ email: e.target.value, invalidEmail: e.target.value.length === 0 });
  }
  cityChangeHandler(e) {
    this.setState({ city: e.target.value, invalidCity: e.target.value.length === 0 });
  }
  ageChangeHandler(e) {
    this.setState({ age: e.target.value, invalidAge: e.target.value.length === 0 });
  }
  genderChangeHandler(e) {
    this.setState({ gender: e.target.value, invalidGender: e.target.value.length === 0 });
  }
  militaryChangeHandler(e) {
    this.setState({ militaryService: e.target.value, invalidMilitary: e.target.value.length === 0 });
  }
  englishChangeHandler(e) {
    this.setState({ language: e.target.value, invalidEnglish: e.target.value.length === 0 });
  }

  removeSkill(index) {
    const skills = [...this.state.skills];
    skills.splice(index, 1);
    this.setState({ skills });
  }
  removeJob(index) {
    const works = [...this.state.works];
    works.splice(index, 1);
    this.setState({ works });
  }
  removeEducation(index) {
    const educations = [...this.state.educations];
    educations.splice(index, 1);
    this.setState({ educations });
  }

  // ==================== تغییر اصلی: وضعیت سربازی دیگر اجباری نیست ====================
  createResume() {
    const s = this.state;
    if (
      !s.name ||
      !s.phone ||
      s.phone.length !== 11 ||
      !s.email ||
      !s.age ||
      !s.city ||
      !s.gender ||
      !s.maritalStatus ||
      !s.language
      // وضعیت سربازی حذف شد - اختیاری است
    ) {
      return swal({
        title: "!خطا",
        text: "!لطفا فیلدهای اصلی را کامل کنید",
        icon: "error",
        button: "!باشه",
      });
    }
    if (s.skills.length === 0) {
      return swal({
        title: "!خطا",
        text: "!حداقل یک مهارت اضافه کنید",
        icon: "error",
        button: "!باشه",
      });
    }
    if (s.works.length === 0) {
      return swal({
        title: "!خطا",
        text: "!حداقل یک سابقه شغلی اضافه کنید",
        icon: "error",
        button: "!باشه",
      });
    }
    if (s.educations.length === 0) {
      return swal({
        title: "!خطا",
        text: "!حداقل یک سابقه تحصیلی اضافه کنید",
        icon: "error",
        button: "!باشه",
      });
    }

    axios
      .post("https://arianaapp.arianaapply.com/api/V1/edit-resume", {
        resume_id: s.resume_id,
        name: s.name,
        phone: s.phone,
        email: s.email,
        address: s.address,
        city: s.city,
        age: s.age,
        gender: s.gender,
        maritalStatus: s.maritalStatus,
        militaryService: s.militaryService || "", // می‌تواند خالی باشد
        language: s.language,
        skills: s.skills,
        works: s.works,
        educations: s.educations,
        resumeEdus: s.resumeEdus,
        resumeSkills: s.resumeSkills,
        resumeWorks: s.resumeWorks,
      })
      .then((response) => {
        console.log(response);
        swal({
          title: "!انجام شد",
          text: "! رزومه شما با موفقیت ویرایش شد",
          icon: "success",
          button: "!باشه",
        });
      })
      .catch((error) => {
        console.log(error);
        swal({
          title: "!خطا",
          text: "!ویرایش رزومه انجام نشد",
          icon: "error",
          button: "!باشه",
        });
      });
  }

  // سال‌های قابل انتخاب
  renderYearOptions() {
    const years = [];
    for (let y = 1340; y <= 1403; y++) {
      years.push(
        <option key={y} value={y}>
          {y}
        </option>
      );
    }
    return years;
  }

  render() {
    const s = this.state;

    return (
      <div className={styles.resume}>
        <div className={styles.resumeBody}>
          <HeaderResume title="" />

          {/* ==================== صفحه ۱: اطلاعات شخصی ==================== */}
          {s.page1 && (
            <>
              <div className={styles.resumeHeader}></div>
              <div className={styles.resumePageCount}>
                <div className={styles.resumePageCountTop}>
                  <span>اطلاعات شخصی</span>
                  <h3>1/4</h3>
                </div>
                <div className={styles.resumePageCountBottom}>
                  <div className={styles.pageCountLine1}>
                    <div className={styles.pageCountLineInside1}></div>
                  </div>
                </div>
              </div>

              <div className={styles.resumeBodyFields}>
                <div className={styles.resumeBodyfield}>
                  <span>نام و نام خانوادگی:</span>
                  <input
                    type="text"
                    placeholder="مهدی بهرامی"
                    onChange={this.nameChangeHandler}
                    value={s.name}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>شماره تماس:</span>
                  <input
                    type="number"
                    placeholder="0912xxxxxxx"
                    onChange={this.phoneChangeHandler}
                    value={s.phone}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>ایمیل:</span>
                  <input
                    type="email"
                    placeholder="Example@mail.com"
                    onChange={this.emailChangeHandler}
                    value={s.email}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>شهر:</span>
                  <input
                    type="text"
                    placeholder="تهران"
                    onChange={this.cityChangeHandler}
                    value={s.city}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>سن:</span>
                  <select onChange={this.ageChangeHandler} value={s.age}>
                    <option value="">انتخاب کنید</option>
                    {Array.from({ length: 61 }, (_, i) => i + 15).map((y) => (
                      <option key={y} value={y}>
                        {y}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>وضعیت تاهل:</span>
                  <select
                    name="maritalStatus"
                    onChange={this.onChange}
                    value={s.maritalStatus}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value="مجرد">مجرد</option>
                    <option value="متاهل">متاهل</option>
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>جنسیت:</span>
                  <select
                    name="gender"
                    onChange={this.genderChangeHandler}
                    value={s.gender}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value="مرد">مرد</option>
                    <option value="زن">زن</option>
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>وضعیت سربازی: (اختیاری)</span>
                  <select
                    name="militaryService"
                    onChange={this.militaryChangeHandler}
                    value={s.militaryService}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value="پایان خدمت">پایان خدمت</option>
                    <option value="معافیت دائم">معافیت دائم</option>
                    <option value="درحال انجام">درحال انجام</option>
                    <option value="مشمول">مشمول</option>
                    <option value="معافیت تحصیلی">معافیت تحصیلی</option>
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>مدرک زبان:</span>
                  <select
                    name="language"
                    onChange={this.englishChangeHandler}
                    value={s.language}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value="بدون مدرک">بدون مدرک</option>
                    <option value="دارای مدرک آیلتس/تافل">
                      دارای مدرک آیلتس/تافل
                    </option>
                  </select>
                </div>

                <div className={styles.resumeBtns}>
                  <button onClick={this.goNext1} className={styles.resumeNextBtn}>
                    <h2>بعدی</h2>
                    <div className={styles.resumeBtnArrow}>
                      <FiArrowLeft />
                    </div>
                  </button>
                </div>
              </div>
            </>
          )}

          {/* ==================== صفحه ۲: سوابق تحصیلی ==================== */}
          {s.page2 && (
            <div>
              <div className={styles.resumeHeader}></div>
              <div className={styles.resumePageCount}>
                <div className={styles.resumePageCountTop}>
                  <span>سوابق تحصیلی</span>
                  <h3>2/4</h3>
                </div>
                <div className={styles.resumePageCountBottom}>
                  <div className={styles.pageCountLine2}>
                    <div className={styles.pageCountLineInside2}></div>
                  </div>
                </div>
              </div>

              <div className={styles.resumeBodyFields}>
                <div className={styles.addItemBody}>
                  {s.educations.map((item, index) => (
                    <div className={styles.addItemCard} key={index}>
                      <TiDelete
                        className={styles.ItemRemove}
                        color="red"
                        onClick={() => this.removeEducation(index)}
                      />
                      <div>
                        {item.university} - {item.major}
                      </div>
                      <div>{item.grade}</div>
                      <div className={styles.addDateStyle}>
                        از {item.from} تا {item.to}
                      </div>
                      {item.description}
                    </div>
                  ))}
                </div>

                <div className={styles.resumeBodyfield}>
                  <span>دانشگاه</span>
                  <input
                    type="text"
                    name="university"
                    onChange={this.onChange}
                    value={s.university}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>رشته</span>
                  <input
                    type="text"
                    name="major"
                    onChange={this.onChange}
                    value={s.major}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>مقطع</span>
                  <select name="grade" onChange={this.onChange} value={s.grade}>
                    <option value="">انتخاب کنید</option>
                    <option value="دکتری">دکتری</option>
                    <option value="فوق لیسانس">فوق لیسانس</option>
                    <option value="لیسانس">لیسانس</option>
                    <option value="فوق دیپلم">فوق دیپلم</option>
                    <option value="دیپلم">دیپلم</option>
                    <option value="زیر دیپلم">زیر دیپلم</option>
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>از تاریخ</span>
                  <select name="fromE" onChange={this.onChange} value={s.fromE}>
                    <option value="">انتخاب کنید</option>
                    {this.renderYearOptions()}
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>تا تاریخ</span>
                  <select name="toE" onChange={this.onChange} value={s.toE}>
                    <option value="">انتخاب کنید</option>
                    {this.renderYearOptions()}
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>توضیحات (اختیاری)</span>
                  <input
                    type="text"
                    name="descriptionE"
                    onChange={this.onChange}
                    value={s.descriptionE || ""}
                  />
                </div>

                <button className={styles.resumeAddBtn} onClick={this.newEdu}>
                  اضافه کردن <BsPlusLg />
                </button>

                <div className={styles.resumeBtns}>
                  <button
                    onClick={this.goBack2}
                    className={styles.resumeBeforeBtn}
                  >
                    <h2>بازگشت به عقب</h2>
                  </button>
                  <button onClick={this.goNext2} className={styles.resumeNextBtn}>
                    <h2>بعدی</h2>
                    <div className={styles.resumeBtnArrow}>
                      <FiArrowLeft />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ==================== صفحه ۳: سوابق شغلی ==================== */}
          {s.page3 && (
            <div>
              <div className={styles.resumeHeader}></div>
              <div className={styles.resumePageCount}>
                <div className={styles.resumePageCountTop}>
                  <span>سوابق شغلی</span>
                  <h3>3/4</h3>
                </div>
                <div className={styles.resumePageCountBottom}>
                  <div className={styles.pageCountLine3}>
                    <div className={styles.pageCountLineInside3}></div>
                  </div>
                </div>
              </div>

              <div className={styles.resumeBodyFields}>
                <div className={styles.addItemBody}>
                  {s.works.map((item, index) => (
                    <div className={styles.addItemCard} key={index}>
                      <TiDelete
                        className={styles.ItemRemove}
                        color="red"
                        onClick={() => this.removeJob(index)}
                      />
                      <div className={styles.addItemStyle}>{item.work}</div>
                      شرکت {item.company}
                      <div className={styles.addDateStyle}>
                        از تاریخ: {item.from} تا تاریخ: {item.to}
                      </div>
                      {item.description}
                    </div>
                  ))}
                </div>

                <div className={styles.resumeBodyfield}>
                  <span>عنوان شغلی</span>
                  <input
                    type="text"
                    name="work"
                    onChange={this.onChange}
                    value={s.work}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>نام شرکت</span>
                  <input
                    type="text"
                    name="company"
                    onChange={this.onChange}
                    value={s.company}
                  />
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>از تاریخ</span>
                  <select name="from" onChange={this.onChange} value={s.from}>
                    <option value="">انتخاب کنید</option>
                    {this.renderYearOptions()}
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>تا تاریخ</span>
                  <select name="to" onChange={this.onChange} value={s.to}>
                    <option value="">انتخاب کنید</option>
                    {this.renderYearOptions()}
                  </select>
                </div>
                <div className={styles.resumeBodyfield}>
                  <span>توضیحات (اختیاری)</span>
                  <input
                    type="text"
                    name="description"
                    onChange={this.onChange}
                    value={s.description}
                  />
                </div>

                <button className={styles.resumeAddBtn} onClick={this.newWork}>
                  اضافه کردن <BsPlusLg />
                </button>

                <div className={styles.resumeBtns}>
                  <button
                    onClick={this.goBack3}
                    className={styles.resumeBeforeBtn}
                  >
                    <h2>بازگشت به عقب</h2>
                  </button>
                  <button onClick={this.goNext3} className={styles.resumeNextBtn}>
                    <h2>بعدی</h2>
                    <div className={styles.resumeBtnArrow}>
                      <FiArrowLeft />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ==================== صفحه ۴: مهارت‌ها ==================== */}
          {s.page4 && (
            <div>
              <div className={styles.resumeHeader}></div>
              <div className={styles.resumePageCount}>
                <div className={styles.resumePageCountTop}>
                  <span>مهارت‌ها</span>
                  <h3>4/4</h3>
                </div>
                <div className={styles.resumePageCountBottom}>
                  <div className={styles.pageCountLine4}>
                    <div className={styles.pageCountLineInside4}></div>
                  </div>
                </div>
              </div>

              <div className={styles.resumeBodyFields}>
                <div className={styles.addItemBody}>
                  {s.skills.map((item, index) => (
                    <div className={styles.addItemCard} key={index}>
                      <TiDelete
                        className={styles.ItemRemove}
                        color="red"
                        onClick={() => this.removeSkill(index)}
                      />
                      {typeof item === "string" ? item : item.skill}
                    </div>
                  ))}
                </div>

                <div className={styles.resumeBodyfield}>
                  <span>مهارت</span>
                  <input
                    type="text"
                    name="skill"
                    placeholder="مهارت جدید"
                    onChange={this.onChange}
                    value={s.skill}
                  />
                </div>

                <button className={styles.resumeAddBtn} onClick={this.newSkill}>
                  اضافه کردن <BsPlusLg />
                </button>

                <button
                  onClick={this.goBack4}
                  className={styles.resumeBeforeBtn}
                >
                  <h2>بازگشت به عقب</h2>
                </button>

                <button
                  className={styles.resumeCreateBtn}
                  onClick={this.createResume}
                >
                  ذخیره تغییرات رزومه
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default SingleResumeWrapper;